/* istanbul ignore file */
export * from "./ILayout";
export * from "./types";
export * from "./product-layout";
export * from "./table-layout";
export * from "./validation";
export * from "./grid-definitions";

export const baseButtonColor = "#888888";
